import { getProfile, getProfileById } from "../Profile/ProfileActions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import { NavigateFunction } from "react-router";
import API from "../../API/API";
import axios from "axios";

export const getAllMembers = createAsyncThunk(
  "members/getAllMembers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllMembers.url,
        method: API.admin.getAllMembers.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addMember = createAsyncThunk(
  "members/addMember",
  async (
    params: {
      buildingId: number;
      firstName: string;
      lastName: string;
      email: string;
      idNumber: string;
      unit: string;
      startDate: string;
      endDate: string;
      onHold: boolean;
      isActive: boolean;
      accessKeyName: string;
      accessKey: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addMember.url,
        method: API.admin.addMember.method,
        data: params,
      });

      toastHelper.success(data?.message);

      params.successHandler();

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateMember = createAsyncThunk(
  "members/updateMember",
  async (
    params: {
      memberId: number;
      buildingId: number;
      firstName: string;
      lastName: string;
      email: string;
      idNumber: string;
      unit: string;
      startDate: string;
      endDate: string;
      onHold: boolean;
      isActive: boolean;
      accessKeyName: string;
      accessKey: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateMember.url,
        method: API.admin.updateMember.method,
        data: params,
      });

      toastHelper.success(data?.message);

      params.successHandler();

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getMemberById = createAsyncThunk(
  "members/getMemberById",
  async (params: { memberId: number }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getMemberById.url + `${params.memberId}`,
        method: API.admin.getMemberById.method,
      });
      return data?.member;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteMember = createAsyncThunk(
  "members/deleteMember",
  async (
    params: { memberId: number; successHandler: () => void },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteMember.url + `${params.memberId}`,
        method: API.admin.deleteMember.method,
      });
      dispatch(getAllMembers());
      toastHelper.success(data?.message);
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const cancelMembership = createAsyncThunk(
  "members/cancelMembership",
  async (
    params: { memberId: number; successHandler: () => void },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.cancelMembership.url + `${params.memberId}`,
        method: API.admin.cancelMembership.method,
      });
      dispatch(getAllMembers());
      toastHelper.success(data?.message);
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const extendMembership = createAsyncThunk(
  "members/extendMembership",
  async (params: { memberId: number }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        url: API.admin.extendMembership.url + `${params.memberId}`,
        method: API.admin.extendMembership.method,
      });
      dispatch(
        getProfileById({
          memberId: params.memberId,
        }),
      );
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const retryPaymentMembership = createAsyncThunk(
  "members/retryPaymentMembership",
  async (params: { memberId: number }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        url: API.admin.retryPaymentMembership.url + `${params.memberId}`,
        method: API.admin.retryPaymentMembership.method,
      });
      dispatch(
        getProfileById({
          memberId: params.memberId,
        }),
      );
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const retrySubscriptionPayment = createAsyncThunk(
  "members/retrySubscriptionPayment",
  async (
    params: { cardId: string; navigate: NavigateFunction },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.retrypayment.url + `${params.cardId}`,
        method: API.members.retrypayment.method,
      });
      dispatch(getProfile({ navigate: params.navigate }));
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearGetMemberById = createAsyncThunk(
  "members/clearMemberById",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGetAllMembers = createAsyncThunk(
  "members/clearGetAllMembers",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const deleteMemberProfile = createAsyncThunk(
  "members/deleteMemberProfile",
  async (params: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteMemberProfile.url,
        method: API.admin.deleteMemberProfile.method,
        data: params,
      });
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
